import templateUrl from "emun.swatch/swatches-cards.htm";
import basicController from "servicestack/basic.controller.properties";
import 'emun.swatch/swatches-cards.client.scss';

export default {
  bindings: {},
  require: {
    container: "^swatchContainer",
    list: "^swatches"
  },
  controller() {
    basicController(this);
    //this.query = this.list.query;
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
